import { render, staticRenderFns } from "./editIntegrationData.vue?vue&type=template&id=4f983c2a"
import script from "./editIntegrationData.vue?vue&type=script&lang=js"
export * from "./editIntegrationData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports